const toggleView = view => dispatch => {
  dispatch({
    type: "TOGGLE_VIEW",
    payload: view,
  });
};

export default toggleView;



// WEBPACK FOOTER //
// ./src/actions/NavbarActions.js